export default [
    {name: 'Barcelona', lat: 41.38879, lng:2.15899, notaries: []},
    {name: 'Toledo', lat:  39.856667, lng: -4.024444, notaries: []},
    {name: 'Palencia', lat:  42.016666, lng: -4.533333, notaries: []},
    {name: 'Lugo', lat: 43.016666, lng:-7.55, notaries: []},
    {name: 'Guadalajara', lat:  40.633713, lng:-3.167394, notaries: []},
    {name: 'Gerona', lat:  41.979401, lng:2.821426, notaries: []},
    {name: 'Lerida', lat:  41.617592, lng:0.62218, notaries: []},
    {name: 'Alicante', lat:  38.34517, lng:-0.48149, notaries: []},
    {name: 'Ourense', lat:  42.336388, lng:-7.863333, notaries: []},
    {name: 'Badajoz', lat:  38.88028, lng:-6.975278, notaries: []},
    {name: 'Santander', lat:  43.462776, lng:-3.805, notaries: []},
    {name: 'Logroño', lat:  42.465, lng:-2.445556, notaries: []},
    {name: 'Leon', lat:  42.605556, lng:-5.57, notaries: []},
    {name: 'Salamanca', lat:  40.961613, lng:-5.667607, notaries: []},
    {name: 'Almería', lat:  36.838139, lng:-2.45974, notaries: []},
    {name: 'Huelva', lat:  37.25, lng:-6.95, notaries: []},
    {name: 'Vitoria', lat:  42.849998, lng:-2.683333, notaries: []},
    {name: 'Pamplona,', lat:  42.816666, lng:-1.65, notaries: []},
    {name: 'Tarragona', lat:  41.115696, lng:1.249594, notaries: []},
    {name: 'Valladolid', lat: 41.652779, lng:-4.723611, notaries: []},
    {name: 'Cádiz', lat: 36.533333, lng:-6.283333, notaries: []},
    {name: 'Murcia', lat: 37.98704, lng:-1.13004, notaries: []},
    {name: 'Granada', lat: 37.178055, lng:-3.600833, notaries: []},
    {name: 'Las Palmas', lat: 28.15, lng:-15.416667, notaries: []},
    {name: 'Malaga', lat: 36.719444, lng:-4.42, notaries: []},
    {name: 'Valencia', lat: 39.466667, lng:-0.375, notaries: []},
    {name: 'Palma de Mallorca', lat: 39.571625, lng:2.650544, notaries: []},
    {name: 'Zaragoza', lat: 41.649693, lng:-0.887712, notaries: []},
    {name: 'Jaén', lat: 37.783642, lng:-3.783768, notaries: []},
    {name: 'Burgos', lat: 42.350388, lng:-3.707206, notaries: []},
    {name: 'Albacete', lat: 38.988266, lng:-1.861976, notaries: []},
    {name: 'Castellón de la Plana', lat: 39.978569, lng:-0.055444, notaries: []},
    {name: 'Melilla', lat: 35.292522, lng:-2.936471, notaries: []},
    {name: 'Ceuta', lat: 35.888287, lng:-5.316195, notaries: []},
    {name: 'A Coruña', lat: 43.362343, lng:-8.41154, notaries: []},
    {name: 'San Sebastián', lat: 43.312691, lng:-1.993332, notaries: []},
    {name: 'Madrid', lat: 40.416775, lng:-3.70379, notaries: []},
    {name: 'Bilbao', lat: 43.262985, lng:-2.935013, notaries: []},
    {name: 'Segovia,', lat: 40.942902, lng:-4.108807, notaries: []},
    {name: 'A Coruña', lat: 43.362343, lng:-8.4115, notaries: []}
]



// WEBPACK FOOTER //
// ./resources/assets/js/factories/province/provincesList.js